import * as t from '../actionTypes';

export const setMediaLinkTracker = (url, text) => ({
  type: t.SET_MEDIA_LINK_TRACKER_MEDIA,
  url,
  text
});

export const resetMediaLinkTracker = () => ({
  type: t.RESET_MEDIA_LINK_TRACKER_MEDIA
});
